import { IconCheck } from '@tabler/icons-react';
import { useState } from 'react';
import { Anchor, Button, Checkbox, Group, Modal, Stack, Text } from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import useFetch from '../../helpers/useFetch';
import { getAuthenticatedUser } from '../../store/authSlice';
import ErrorMessage from '../ErrorMessage';

const AcceptTermsModal = ({ isOpen }) => {
  const fetch = useFetch();
  const { domain } = useSelector((state) => state.domain);
  const { account } = useSelector((state) => state.account);

  const dispatch = useDispatch();

  const [working, setWorking] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(!!domain.termsAcceptedAt);
  const [pricingAccepted, setPricingAccepted] = useState(!!domain.pricingAcceptedAt);

  const [error, setError] = useState();
  const pricingUrl = account.partner?.pricingUrl || 'https://releva.ai/pricing/';

  const save = () => {
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}`, {
      method: 'PUT',
      body: JSON.stringify({
        ...domain,
        termsAcceptedAt: termsAccepted ? new Date() : undefined,
        pricingAcceptedAt: pricingAccepted ? new Date() : undefined,
      }),
    })
      .then(() => {
        setWorking(false);
        dispatch(getAuthenticatedUser());
      })
      .catch(setError);
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (!domain || !account) {
    return;
  }

  return (
    <Modal opened={isOpen} onClose={() => {}} title="Welcome to Releva" withCloseButton={false}>
      <Stack gap="md">
        <Text>
          We're excited to welcome you aboard! Before you begin, kindly take a moment to review and agree to the
          following terms:
        </Text>
        <Checkbox
          name="termsAccepted"
          label={
            <>
              I accept Releva's{' '}
              <Anchor href="https://releva.ai/terms-of-use/" target="_blank" rel="noreferrer">
                Terms of Use
              </Anchor>
            </>
          }
          onChange={(e) => setTermsAccepted(e.currentTarget.checked)}
          checked={termsAccepted}
        />
        <Checkbox
          name="pricingAccepted"
          label={
            <>
              I accept Releva's{' '}
              <Anchor href={pricingUrl} target="_blank" rel="noreferrer">
                Pricing Policy
              </Anchor>
            </>
          }
          onChange={(e) => setPricingAccepted(e.currentTarget.checked)}
          checked={pricingAccepted}
        />
        <Group justify="flex-end" mt="md">
          <Button disabled={!pricingAccepted || !termsAccepted || working} onClick={save}>
            <IconCheck size={16} /> Save
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default AcceptTermsModal;
